'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = require('prop-types');
var PropTypes__default = _interopDefault(PropTypes);
var layoutTree = require('./layoutTree.js');
var _slicedToArray = _interopDefault(require('@babel/runtime/helpers/slicedToArray'));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// TODO: This prevents SSR of components since it uses `useState`. This could be
// fixed using a while loop and using `ReactDOMServer.renderToString`, but that
// can incur a performance penalty for rendering many components to string.
//
// We should measure how much of an impact this penalty incurs and see if we can
// either mitigate it or not worry about it.
//
// Another option is to try to render all of the components and some of them
// will not render due to conditions, rather than us iterating here.
var WaterfallOrchestrator = function WaterfallOrchestrator(_ref) {
  var children = _ref.children,
    feature = _ref.feature;
  var _React$useState = React.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    index = _React$useState2[0],
    setIndex = _React$useState2[1];
  if (index > children.length - 1) return /*#__PURE__*/React.createElement(React.Fragment, null);
  var node = children[index];
  var next = function next() {
    setIndex(index + 1);
  };
  return feature({
    node: Object.freeze(_objectSpread(_objectSpread({}, node), {}, {
      children: null
    })),
    next: next
  });
};
WaterfallOrchestrator.propTypes = {
  children: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.oneOf([layoutTree.TreeNodeTypes.FEATURE]).isRequired,
    name: PropTypes.string.isRequired,
    options: PropTypes.shape({
      layout: PropTypes.oneOf(Object.values(layoutTree.FeatureLayout)),
      assetId: PropTypes.string,
      sectionDividerId: PropTypes.string,
      fixedPanelHeight: PropTypes.string,
      conditions: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({
        type: PropTypes.oneOf([layoutTree.ConditionType.SHIPMENT_STATUS]).isRequired,
        status: PropTypes.oneOf(Object.values(layoutTree.ShipmentStatusConditionStatus)).isRequired
      }), PropTypes.shape({
        type: PropTypes.oneOf([layoutTree.ConditionType.CARRIER_MONIKER]).isRequired,
        carrierMoniker: PropTypes.oneOf(Object.values(layoutTree.CarrierConditionMoniker)).isRequired
      })]).isRequired)
    })
  }).isRequired).isRequired,
  feature: PropTypes.func.isRequired
};

exports.default = WaterfallOrchestrator;
